import { SUPPORTED_CHAINS } from '@/constants/chain';
import { ENV } from '@/environment/client';

export const ROOT_URL_PRODUCTION = 'https://matcha.xyz';

export const ROOT_URLS = {
  development: 'http://localhost:3000',
  preview: `https://${ENV.NEXT_PUBLIC_VERCEL_URL}`,
  production: ROOT_URL_PRODUCTION,
};
export const ROOT_URL = ENV.NEXT_PUBLIC_VERCEL_ENV
  ? ROOT_URLS[ENV.NEXT_PUBLIC_VERCEL_ENV]
  : undefined;

// Default - Home Page
export const DEFAULT_SITE_TITLE = 'Matcha | DEX aggregator by 0x | Search, trade, done.';
export const DEFAULT_SITE_DESCRIPTION = `Matcha DEX aggregator | Search and trade over +9 million tokens across +100 exchanges on ${SUPPORTED_CHAINS.length} chains. Trade now.`;
const DEFAULT_SITE_NAME = 'Matcha';
const TWITTER_HANDLE = '@matchaxyz';

export const DEFAULT_SEO_CONFIG = {
  title: DEFAULT_SITE_TITLE,
  description: DEFAULT_SITE_DESCRIPTION,
  canonical: ROOT_URL_PRODUCTION,
  robotsProps: {
    notranslate: false,
    noarchive: true,
    nosnippet: false,
    maxSnippet: DEFAULT_SITE_DESCRIPTION.length + 3,
  },
  openGraph: {
    type: 'website',
    locale: 'en_US',
    url: ROOT_URL_PRODUCTION,
    title: DEFAULT_SITE_TITLE,
    description: DEFAULT_SITE_DESCRIPTION,
    site_name: DEFAULT_SITE_NAME,
    images: [
      {
        url: `${ROOT_URL_PRODUCTION}/images/og/social-banner.jpg`,
        width: 1200,
        height: 630,
        alt: 'Matcha',
      },
    ],
  },
  twitter: {
    handle: TWITTER_HANDLE,
    site: TWITTER_HANDLE,
    cardType: 'summary_large_image',
  },
  additionalMetaTags: [
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover',
    },
    {
      name: 'twitter:title',
      content: DEFAULT_SITE_TITLE,
    },
    {
      name: 'twitter:description',
      content: DEFAULT_SITE_DESCRIPTION,
    },
    {
      name: 'twitter:image',
      content: `${ROOT_URL_PRODUCTION}/images/og/social-banner.jpg`,
    },
    {
      name: 'twitter:url',
      content: ROOT_URL_PRODUCTION,
    },
  ],
};
